import React from 'react';
import { IconBase } from '../Base';
export const IconEventOutgoing = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("path", { d: "M5.75 14.25L14.25 5.75", style: { stroke: 'var(--icon-color)' }, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M7.25 5.75H14.25V12.75", style: { stroke: 'var(--icon-color)' }, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })));
};
//# sourceMappingURL=Outgoing.js.map